/**
 * Client tarafında hata yakalama ve loglama yardımcı fonksiyonları
 */

/**
 * API hatalarını konsola detaylı bir şekilde loglar
 */
export const logAPIError = (error: any, operationName: string): void => {
  console.group(`API Hatası: ${operationName}`);
  
  console.error('Hata mesajı:', error.message);
  
  if (error.response) {
    // Sunucu yanıtı ile dönen hata
    console.error('Sunucu yanıtı:', {
      status: error.response.status,
      statusText: error.response.statusText,
      data: error.response.data
    });
  } else if (error.request) {
    // İstek yapıldı ama yanıt alınamadı
    console.error('İstek yapıldı, yanıt alınamadı:', error.request);
  } else {
    // İstek oluşturulurken bir şeyler yanlış gitti
    console.error('İstek oluşturma hatası:', error.message);
  }
  
  console.error('Hata konfigürasyonu:', error.config);
  console.error('Tam hata:', error);
  
  console.groupEnd();
};

/**
 * Kullanıcıya gösterilecek hata mesajını hazırlar
 */
export const getErrorMessage = (error: any): string => {
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  } else if (error.message) {
    return error.message;
  } else {
    return 'Bilinmeyen bir hata oluştu.';
  }
};

/**
 * Hataları hem loglar hem de kullanıcı dostu mesaj döndürür
 */
export const handleAPIError = (error: any, operationName: string): string => {
  logAPIError(error, operationName);
  return getErrorMessage(error);
};
